import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  RequestOtpViaMsisdnDTO,
  ValidateOtpDTO,
} from "@core/models/dto.models";
import {
  RequestOtpApiResponse,
  ValidateOtpApiResponse,
} from "@core/models/api.response";

@Injectable({
  providedIn: "root",
})
export class OtpService {
  constructor(private http: HttpClient) {}

  requestOtp(
    data: RequestOtpViaMsisdnDTO
  ): Observable<HttpResponse<RequestOtpApiResponse>> {
    return this.http.post<RequestOtpApiResponse>(
      `${environment.apiUri}/verify/request-otp`,
      { msisdn: data.msisdn, guid: data.guid },
      { observe: "response" }
    );
  }

  validateOtp(mobileOTP: ValidateOtpDTO): Observable<ValidateOtpApiResponse> {
    //return of({ match: true } as ValidateOtpApiResponse); //test

    return this.http.post<ValidateOtpApiResponse>(
      `${environment.apiUri}/verify/check-otp`,
      { otp: mobileOTP.otp, msisdn: mobileOTP.msisdn, guid: mobileOTP.guid }
    );
  }
}
